<template>
    <AppHeader fixed>
        <SidebarToggler class="d-lg-none" display="md" mobile />
        <b-link class="navbar-brand" to="#">
            <img class="navbar-brand-full" src="/logo.png" height="25" alt="Logo">
            <img class="navbar-brand-minimized" src="/logo.png" width="30" height="30" alt="Logo">
        </b-link>
        <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
        <b-navbar-nav class="ml-auto">
            <div class="px-1 text-right" style="line-height: 120%">
                <span class="font-weight-bold">{{ name }}</span><br />
                <span>{{ role }}</span>
            </div>
            <DefaultHeaderDropdownAccnt class="mr-2" @change-password="didChangePassword" @logout="didLogout" />
        </b-navbar-nav>
    </AppHeader>
</template>
<script>
import { Header as AppHeader, SidebarToggler, AsideToggler } from '@coreui/vue'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
    name: 'DefaultHeader',
    components: {
        AsideToggler,
        AppHeader,
        DefaultHeaderDropdownAccnt,
        SidebarToggler
    },
    data() {
        return {

            name: localStorage.getItem("fullname"),
            role: localStorage.getItem("roleName")

        }
    },
    methods: {

        didChangePassword() {
            this.$emit("change-password")
        },

        didLogout() {
            this.$emit("logout")
        }

    }
}
</script>
